import TemplateView from '../../../../../../js/TemplateView'

export default class UserSelectionInfoListItem extends TemplateView {

    constructor({
        text,
    }) {
        super()

        this.params = {
            text,
        }
    }

    templateHtml() {
        return '<li class="userSelectionInfoListItem"><%=text%></li>'
    }

    templateModel() {
        return {
            text: this.params.text,
        }
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/usersDetailedInfo/UserSelectionInfoListItem.js